// ===== 1. Imports =====
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

// ===== 2. Configuración de Firebase =====
const firebaseConfig = {
  apiKey: "AIzaSyCMozplyn1fzNdT2C5jViQtnp8oQrqIWpo",
  authDomain: "filma-d74e7.firebaseapp.com",
  projectId: "filma-d74e7",
  storageBucket: "filma-d74e7.firebasestorage.app",
  messagingSenderId: "930086129353",
  appId: "1:930086129353:web:41e86c8cce9f4525c20718",
};

// ===== 3. Inicialización =====
const app = initializeApp(firebaseConfig);

// ===== 4. Exportaciones =====
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);
